import * as React from 'react';
import * as dateFns from 'date-fns';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
} from 'arbina-ui';
import { PurchaseWallpaperPack } from 'types';
import * as style from './style.sass';

interface Properties {
  items: PurchaseWallpaperPack[];
  onStartEditItem: (pack: PurchaseWallpaperPack) => any;
  onDeleteItem: (pack: PurchaseWallpaperPack) => any;
  onSetItemActive: (pack: PurchaseWallpaperPack) => any;
}

export class PackTable extends React.Component<Properties> {
  render() {
    const { items, onStartEditItem, onDeleteItem, onSetItemActive } = this.props;

    return (<Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>
            Items
          </TableHeaderCell>
          <TableHeaderCell>
            Created
          </TableHeaderCell>
          <TableHeaderCell>
            Updated
          </TableHeaderCell>
          <TableHeaderCell/>
        </TableRow>
      </TableHeader>
      <TableBody>
        <>
          {!items.length ? <TableRow>
            <TableCell colSpan={5}>No items to show.</TableCell>
          </TableRow> : null}
          {items.map(pack => (<TableRow
            key={pack.id}
            className={pack.active ? style.active : ''}
          >
            <TableCell>
              {pack.items.map(item => (<img className={style.preview}
                key={item.imageUrl}
                src={item.imageUrl}
              />))}
            </TableCell>
            <TableCell>
              {dateFns.format(new Date(pack.createdAt), 'DD.MM.YYYY HH:mm:ss')}
            </TableCell>
            <TableCell>
              {pack.updatedAt ?
                dateFns.format(new Date(pack.updatedAt), 'DD.MM.YYYY HH:mm:ss') :
                null}
            </TableCell>
            <TableCell className={style.tools}>
              <a onClick={onStartEditItem.bind(this, pack)}>⚙</a>
              <a onClick={onDeleteItem.bind(this, pack)}>🗑</a>
              {!pack.active && <a onClick={onSetItemActive.bind(this, pack)}>Use this pack</a>}
            </TableCell>
          </TableRow>))}
        </>
      </TableBody>
    </Table>);
  }
}
